import 'observability/init'
import 'react-perfect-scrollbar/dist/css/styles.css'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './i18n/i18n'
import { StrictMode } from 'react'
import * as ReactDOMClient from 'react-dom/client'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { LicenseInfo } from '@mui/x-license'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { StyledEngineProvider } from '@mui/material/styles'
import ChatClient from 'util/ChatClient'
import ErrorBoundary from 'pages/errors/ErrorBoundary'
import App from './App'
import { PracticeProvider } from './contexts/PracticeContext'
import { SettingsProvider } from './contexts/SettingsContext'
import store from './store'
import { initSentry } from 'observability/sentry'
import CustomizedLabels from './util/CustomizedLabels'
import { MUI_LICENSE } from './config'

LicenseInfo.setLicenseKey(MUI_LICENSE)

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY as string, {
	betas: ['us_bank_account_beta_2'],
	apiVersion: '2020-08-27; us_bank_account_beta=v2'
})

initSentry()
CustomizedLabels.init()
ChatClient.init()

const rootElement = document.getElementById('root') as Element
const root = ReactDOMClient.createRoot(rootElement)

root.render(
	<StrictMode>
		<StyledEngineProvider injectFirst>
			<ErrorBoundary>
				<HelmetProvider>
					<ReduxProvider store={store}>
						<BrowserRouter>
							<PracticeProvider>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<SettingsProvider>
										<Elements stripe={stripePromise}>
											<App />
										</Elements>
									</SettingsProvider>
								</LocalizationProvider>
							</PracticeProvider>
						</BrowserRouter>
					</ReduxProvider>
				</HelmetProvider>
			</ErrorBoundary>
		</StyledEngineProvider>
	</StrictMode>
)
